// extracted by mini-css-extract-plugin
module.exports = {"containerArticles":"ControlPrevention_containerArticles__qp0fq","articles":"ControlPrevention_articles__1ZNIa"};